module.exports = __webpack_public_path__ + "static/media/MonsterTruckLogo.f46faf27.png";